module.exports = __webpack_public_path__ + "img/pink-mimosa-glass.fc26244e.svg";